import styled from "styled-components";

const LeftPartInner = styled.div`
  display: flex;
`;
export default LeftPartInner;
